<template>
    <div>
 
            <!-- blog-details-area -->
            <section class="blog__details-area">
                <div class="container">
                    <div class="blog__inner-wrap">
                        <div class="row">
                            <div class="col-70">
                                <div class="blog__details-wrap">
                                    <!-- <div class="blog__details-thumb">
                                        <img src="assets/img/blog/blog_details01.jpg" alt="Apexa" />
                                    </div> -->

                                    <!-- <pre>{{ list_data }}</pre> -->
                                    
                                    <div class="blog__details-content">
                                        <h2 class="title">{{ $route.name }}</h2>                                    
                                        <p v-for="(item, index) in list_data" :key="index" v-html="item.uraian"></p>
                                    </div>
                                    
 
                                </div>
                            </div>

                            <sidecontentnews></sidecontentnews>

                            
                        </div>
                    </div>
                </div>
            </section>        
    </div>
</template>

 
<script>
export default {
    data() {
        return {
            list_data:[],
            jml_data:0,
            kategori:'Bidang Aset',
        }
    },
    methods: {
 
    getView() { 
        fetch(this.$store.state.URL.bpkad_unit_kerja + 'view', {
            method: "POST",
            headers: {
            "content-type": "application/json", 
            }, 
            body:JSON.stringify(
                {
                data_ke:1,
                cari_value:'', 
                kategori:this.kategori
            }
            )
        })
        .then(res => res.json())
        .then(res_data => { 
            this.list_data = res_data  
            console.log(res_data); 
        });     
    },        
    },
    mounted() {
        this.getView()
        
    },
}
</script>